import { render, staticRenderFns } from "./CourseCardMaterialsRequirements.vue?vue&type=template&id=7b747da4&"
import script from "./CourseCardMaterialsRequirements.vue?vue&type=script&lang=js&"
export * from "./CourseCardMaterialsRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ListIcon: require('/builds/marketing/abstracta.academy-website/components/ListIcon.vue').default})
